import { render } from "./visitPage.vue?vue&type=template&id=fff823e4&scoped=true"
import script from "./visitPage.vue?vue&type=script&lang=js"
export * from "./visitPage.vue?vue&type=script&lang=js"

import "./visitPage.vue?vue&type=style&index=0&id=fff823e4&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff823e4"]])

export default __exports__